import { SibBaseObject } from "../BaseObject/SibBaseObject";
import { Breakeven } from "./breakevenamount";
import { Address } from "./address";
import { PersonInfo } from "./personinfo";
import { ChequeDetail } from "./chequedetail";

export class Contracts extends SibBaseObject {
    name: string;
    type: string;
    totalAssets: number;
    totalSqFt: number;
    areas: any[] = [];
    startDate: Date;
    endDate: Date;
    breakevens: Breakeven[] = [];
    id: string;
    address: Address = new Address();
    person: PersonInfo = new PersonInfo();
    status: any;
    cheques: ChequeDetail[] = [];
    documents: Document[] = [];
    contractId: string;
}